import Cookies from 'js-cookie';
import Notification from './NotificationsManager';

class Account {
  static set(data) {
    localStorage.setItem('account', JSON.stringify(data));
  }

  static setToken(token, remember) {
    if (remember) {
      localStorage.setItem('token', token);
    } else {
      Cookies.set('token', token);
    }
  }

  static get() {
    try {
      const account = localStorage.getItem('account');
      return JSON.parse(account) || {};
    } catch (e) {
      return {};
    }
  }

  static add(data) {
    this.set({ ...this.get(), ...data });
  }

  static getToken() {
    return localStorage.getItem('token') || Cookies.get('token') || '';
  }

  static async delete() {
    await Notification.disable();
    localStorage.removeItem('token');
    localStorage.removeItem('account');
    Cookies.remove('token');
  }
}

export default Account;
